var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 2.66669V13.3334M1.3335 5.33335H13.3335C13.6871 5.33335 14.0263 5.47383 14.2763 5.72388C14.5264 5.97393 14.6668 6.31307 14.6668 6.66669V13.3334M1.3335 11.3334H14.6668M4.00016 5.33335V11.3334",
    stroke: "#09090B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedIcon2);
export default __webpack_public_path__ + "static/media/bed-icon-2.65c3015077bd37cfbea3d3a53fb3d061.svg";
export { ForwardRef as ReactComponent };